import { TweenMax, Power2 } from "gsap";

export default class UI {
    constructor() {
        this._init();
    }

    _init() {
        this._ui();
    }

    _ui() {
        [...document.querySelectorAll(".js-top")].forEach(($elem) => {
            $elem.addEventListener("click", (e) => {
                e.preventDefault();
                TweenMax.to([document.querySelector("html"), document.querySelector("body")], 0.5, { scrollTop: 0, ease: Power2.easeOut });
            });
        });

        const links = document.querySelectorAll("a.js-smooth");
        for (let i = 0; i < links.length; i++) {
            const $a = links[i];

            $a.addEventListener("click", (e) => {
                e.preventDefault();
                const $target = document.querySelector($a.getAttribute("href"));
                const targetPos = $target.getBoundingClientRect().top + window.pageYOffset;
                TweenMax.to([document.querySelector("html"), document.querySelector("body")], 0.7, { scrollTop: targetPos, ease: Power2.easeOut });
            });
        }
    }
}
